/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Suchmaschine, an die der Suchschlitz der Kachelseite uebergibt.
 * @export
 */
export const DatabaseLinkGallerySearchEngine = {
    Google: 'GOOGLE',
    Bing: 'BING'
} as const;
export type DatabaseLinkGallerySearchEngine = typeof DatabaseLinkGallerySearchEngine[keyof typeof DatabaseLinkGallerySearchEngine];


export function DatabaseLinkGallerySearchEngineFromJSON(json: any): DatabaseLinkGallerySearchEngine {
    return DatabaseLinkGallerySearchEngineFromJSONTyped(json, false);
}

export function DatabaseLinkGallerySearchEngineFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseLinkGallerySearchEngine {
    return json as DatabaseLinkGallerySearchEngine;
}

export function DatabaseLinkGallerySearchEngineToJSON(value?: DatabaseLinkGallerySearchEngine | null): any {
    return value as any;
}

